<template>
    <b-card>
        <h3>Successfully Logged Out!</h3>
        <p>
            Redirecting to
            <b-link :to="redirectRoute">
                <span>home</span>
            </b-link>
            in {{ redirectTime }} seconds ...
        </p>
    </b-card>
</template>

<script>
export default {
    metaInfo() {
        return { title: 'Logout' };
    },

    data() {
        return {
            redirectTime: 3,
            redirectRoute: { name: process.env.VUE_APP_GUEST_HOME_ROUTE }
        };
    },

    mounted() {
        setTimeout(() => {
            this.$store.dispatch('auth/clearToken');
            this.$router.push(this.redirectRoute);
        }, this.redirectTime * 1000);
    }
};
</script>

<style lang="scss" scoped>
@import '$StyleVars';

</style>
